import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX, LocaleX } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, VStack, XImage, XText } from "IZOX/_X";

/**
 * @augments {Component<Props, State>}
 */
class HContactInfo extends Component {

  static propTypes = {
    info: PropsType.object
  }

  static defaultProps = {
    info: {}
  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(HContactInfo.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  render(){
    let {info, fontSize} = this.props;
    let {contactinfo} = info ?? {};
    let {phone, whatsapp, fax, email, address} = contactinfo ?? {};
    let iconSize = 30;
    return (
      <VStack fullWidth HAlign="[">
        <VStack pV={40} fullWidth spacing={16}>
          <HStack>
            <XText color={ColorX.CSS("Stone")} bold fontSize={fontSize ?? 28}>
              {LocaleX.Parse({
                EN: "Contact Information",
                TC: "聯絡資料"
              })}
            </XText>
          </HStack>
          <HStack spacing={16}>
            <VStack width={"50%"} HAlign="[" spacing={16}>
              <HStack spacing={5} HAlign="[" width={"auto"}>
                <XImage source="/Images/Icons/phonecom.png" 
                  width={iconSize} height={iconSize} noResize/>
                <XText fontSize={18} color={ColorX.CSS("Stone")}>{phone}</XText>
              </HStack>
              <HStack spacing={5} HAlign="[" width={"auto"}>
                <XImage source="/Images/Icons/fax.png" 
                  width={iconSize} height={iconSize} noResize/>
                <XText fontSize={18} color={ColorX.CSS("Stone")}>{fax}</XText>
              </HStack>
            </VStack>
            <VStack width={"50%"} HAlign="[" spacing={16}>
              <HStack spacing={5} HAlign="[" width={"auto"}>
                <XImage source="/Images/Icons/whatsapp.png" 
                  width={iconSize} height={iconSize} noResize/>
                <XText fontSize={18} color={ColorX.CSS("Stone")}>{whatsapp}</XText>
              </HStack>
              <HStack spacing={5} HAlign="[" width={"auto"}>
                <XImage source="/Images/Icons/email.png"
                  width={iconSize} height={iconSize} noResize/>
                <XText fontSize={18} color={ColorX.CSS("Stone")}>{email}</XText>
              </HStack>
            </VStack>
          </HStack>
          <HStack spacing={5} HAlign="[">
            <XImage source="/Images/Icons/location.png"
              width={iconSize} height={iconSize} noResize/>
            <XText color={ColorX.CSS("Stone")}>{LocaleX.Parse(address)}</XText>
          </HStack>
        </VStack>
      </VStack>
    );
  }

}

export default observer(HContactInfo);
